/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditRequestBulkEditReleaseLink
 */
export interface BulkEditRequestBulkEditReleaseLink {
    /**
     * Existing release id, or null to create the release from source + metadata
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    releaseId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    source?: BulkEditRequestBulkEditReleaseLinkSourceEnum;
    /**
     * Release id at the source; may carry a URL when the source has no id (4.3.2)
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    sourceId?: string | null;
    /**
     * The release's id(s) at its source, e.g. the Discogs release id — the only value that reaches `sourceReleaseId`. Required and non-empty on both paths: `release_id` is the WMC id, and the service does not derive this from `source_id`.
     * @type {Array<string>}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    sourceReleaseIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    releaseTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    dateReleased?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    releaseLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    catNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    mediaType?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditRequestBulkEditReleaseLink
     */
    format?: string;
}


/**
 * @export
 */
export const BulkEditRequestBulkEditReleaseLinkSourceEnum = {
    Discogs: 'discogs',
    Mb: 'MB',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl',
    Other: 'other'
} as const;
export type BulkEditRequestBulkEditReleaseLinkSourceEnum = typeof BulkEditRequestBulkEditReleaseLinkSourceEnum[keyof typeof BulkEditRequestBulkEditReleaseLinkSourceEnum];


/**
 * Check if a given object implements the BulkEditRequestBulkEditReleaseLink interface.
 */
export function instanceOfBulkEditRequestBulkEditReleaseLink(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sourceReleaseIds" in value;

    return isInstance;
}

export function BulkEditRequestBulkEditReleaseLinkFromJSON(json: any): BulkEditRequestBulkEditReleaseLink {
    return BulkEditRequestBulkEditReleaseLinkFromJSONTyped(json, false);
}

export function BulkEditRequestBulkEditReleaseLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditRequestBulkEditReleaseLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': !exists(json, 'release_id') ? undefined : json['release_id'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'sourceReleaseIds': json['source_release_ids'],
        'releaseTitle': !exists(json, 'release_title') ? undefined : json['release_title'],
        'dateReleased': !exists(json, 'date_released') ? undefined : json['date_released'],
        'releaseLabels': !exists(json, 'release_labels') ? undefined : json['release_labels'],
        'catNumbers': !exists(json, 'cat_numbers') ? undefined : json['cat_numbers'],
        'mediaType': !exists(json, 'media_type') ? undefined : json['media_type'],
        'format': !exists(json, 'format') ? undefined : json['format'],
    };
}

export function BulkEditRequestBulkEditReleaseLinkToJSON(value?: BulkEditRequestBulkEditReleaseLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'source': value.source,
        'source_id': value.sourceId,
        'source_release_ids': value.sourceReleaseIds,
        'release_title': value.releaseTitle,
        'date_released': value.dateReleased,
        'release_labels': value.releaseLabels,
        'cat_numbers': value.catNumbers,
        'media_type': value.mediaType,
        'format': value.format,
    };
}

